import { WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import {
  SectionEmptyState,
  SectionHeader,
  SectionPanel,
} from "../../../componentLibrary/SectionPanel";
import ToolboxSectionToolsAccordion from "../../../components/ToolboxSectionToolsAccordion";
import type {
  ToolboxToolSectionGroup,
  ToolboxToolItem,
} from "../../../utils/toolboxTools";
import type { ModuleI } from "../../../types";

interface Props {
  topic: ModuleI;
  toolboxToolSections: ToolboxToolSectionGroup[];
  onSelectTool: (tool: ToolboxToolItem) => void;
}

export default function MyToolsPanel({
  topic,
  toolboxToolSections,
  onSelectTool,
}: Props) {
  return (
    <SectionPanel>
      <SectionHeader
        icon={
          <WrenchScrewdriverIcon className="w-5 h-5 text-electrum-300 shrink-0" />
        }
        title="My Tools"
        action={toolboxToolSections.length === 0 ? undefined : "View Responses"}
        actionTo={toolboxToolSections.length === 0 ? undefined : "responses"}
      />
      {toolboxToolSections.length === 0 ? (
        <SectionEmptyState>
          <p className="text-sm text-gray-400 py-2">
            No tools are available for {topic.title} yet.
          </p>
        </SectionEmptyState>
      ) : (
        <div className="flex flex-col gap-2 py-2">
          {toolboxToolSections.map((section) => (
            <ToolboxSectionToolsAccordion
              key={section.sectionId}
              section={section}
              onSelectTool={onSelectTool}
            />
          ))}
        </div>
      )}
    </SectionPanel>
  );
}
